export { InlineNotification } from './InlineNotification';
export type { InlineNotificationType, InlineNotificationProps } from './types';
